import { render } from "./refund_policy.vue?vue&type=template&id=1ea3727a"
import script from "./refund_policy.vue?vue&type=script&lang=js"
export * from "./refund_policy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__